exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-wrapper[data-v-0057032c]{max-width:150px}.image-wrapper img[data-v-0057032c]{width:100%;height:auto}", ""]);

// exports
